import type { Carousel } from '@ps/web-martech-cms-types';
import React from 'react';

import CasinoGamesCarousel from './CasinoGamesCarousel';
import DefaultCarousel from './DefaultCarousel/DefaultCarousel';
import ProspectHomepageCarousel from './ProspectHomepageCarousel/ProspectHomepageCarousel';

const CMSCarousel: React.FC<Carousel> = ({
  auto_rotate: autoRotate,
  prospect_homepage_slides: prospectHomepageSlides,
  rotation_speed: rotationSpeed,
  slides,
  variant
}) => {
  const slideSpeed = Number(rotationSpeed) * 1000;

  switch (variant) {
    case 'Casino Games':
      return <CasinoGamesCarousel autoRotate={autoRotate} slideSpeed={slideSpeed} />;
    case 'Prospect Homepage':
      return (
        <ProspectHomepageCarousel
          autoRotate={autoRotate}
          slides={prospectHomepageSlides}
          slideSpeed={slideSpeed}
        />
      );
    case 'Default':
    default:
      return <DefaultCarousel autoRotate={autoRotate} slides={slides} slideSpeed={slideSpeed} />;
  }
};

export default CMSCarousel;
